module.exports = __webpack_public_path__ + "static/media/bg7.e7efa0f9.jpg";